import React from 'react';
import SystemGroupBody from './components/system-group-body';

function ContactGroup () {
	return (
		<div className="system-group">
			<SystemGroupBody/>
		</div>
	)
}

export default ContactGroup;
